import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';
import { TipoCapacitacion } from '@/app/models/interface/tipo-capacitacion.model';

@Injectable({ providedIn: 'root' })
export class TipoCapacitacionService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'tipo-capacitacion/';

  create(data: Partial<TipoCapacitacion>) {
    return this.http
      .post<CustomResponse<TipoCapacitacion>>(this.url, data)
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          return d;
        }),
      );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<
        CustomResponse<PaginatorModel<TipoCapacitacion[], HasPagination>>
      >(this.url, { params })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          return d;
        }),
      );
  }

  findOne(id: string) {
    const url = this.url + id;
    return this.http.get<CustomResponse<TipoCapacitacion>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return d;
      }),
    );
  }

  update(tipo: Partial<TipoCapacitacion>) {
    const url = this.url + tipo.id;
    return this.http.put<CustomResponse<TipoCapacitacion>>(url, tipo).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return d;
      }),
    );
  }

  changeState(state: boolean, id: string) {
    const url = this.url + id;
    return this.http
      .patch<CustomResponse<TipoCapacitacion>>(url, { state })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          return d;
        }),
      );
  }
}
